import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '../common/models/common.model';
import { Expense, ExpenseStatus, ExpenseSummaryResponse, UpdateExpenseStatusResponse } from './expense.model';
import { HttpParams } from '@angular/common/http';
import { buildHttpParams } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class ExpensesService {
  private _baseUrl: string = 'expenses/';

  constructor(private _apiService: ApiService) {}

  list(query: Record<string, any> | null = null): Observable<PaginatedResponse<Expense, ExpenseSummaryResponse>> {
    const params = buildHttpParams(query);
    return this._apiService.get(this._baseUrl, params);
  }

  update(id: string, reqBody: any): Observable<UpdateExpenseStatusResponse> {
    return this._apiService.patch(`${this._baseUrl}${id}/update-status/`, reqBody);
  }

  export(filters: { employee_id?: string; from_date?: string; to_date?: string }): Observable<Blob> {
    const query: Record<string, string> = {};
    if (filters.employee_id) query['employee_id'] = filters.employee_id;
    if (filters.from_date) query['from_date'] = filters.from_date;
    if (filters.to_date) query['to_date'] = filters.to_date;
    const params = buildHttpParams(query);
    return this._apiService.getBlob(`${this._baseUrl}export/`, params);
  }
}
